import React from 'react';
import { StandardButton } from '@eika/button';
const InfoSection = _ref => {
  var _section$contentText;
  let {
    section,
    onFinishRedirectURL,
    onButtonClick,
    statusCallback
  } = _ref;
  const buttonClick = () => {
    const status = section.finalizeWithStatus;
    if (status) {
      if (statusCallback) {
        statusCallback(status);
      }
      if (onFinishRedirectURL) {
        window.location.href = onFinishRedirectURL;
      }
    } else {
      onButtonClick();
    }
  };
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("h2", {
    className: "info-header"
  }, section.headerText), /*#__PURE__*/React.createElement("div", {
    className: "info-content",
    dangerouslySetInnerHTML: {
      __html: (_section$contentText = section.contentText) !== null && _section$contentText !== void 0 ? _section$contentText : ''
    }
  }), /*#__PURE__*/React.createElement(StandardButton, {
    className: "progress-next-button info-button",
    onClick: buttonClick
  }, section.buttonText));
};
export default InfoSection;